import tracking from 'dibs-tracking';

function trackPersonalizationImpression({ recommendation, startIndex }) {
    startIndex = startIndex * recommendation.items.length;

    tracking.trackEcommerce({
        type: 'productImpression',
        products: recommendation.items.map((item, index) => ({
            id: item.serviceId,
            name: item.title,
            category: recommendation.url.slice(1, -1),
            brand: item.seller.sellerId,
            variant: `homepage - ${recommendation.variant}`,
            position: index + startIndex + 1,
            list: 'personalized-items-carousel',
        })),
    });
}

function trackPersonalizationMount() {
    tracking.trackEcommerce({
        type: 'promotionImpression',
        promotions: [
            {
                id: 'personalized-items-categories-carousel',
                name: 'Personalized Items and Categories Carousel',
                creative: 'Personalized Items and Categories Carousel',
                position: 1,
            },
        ],
    });
}

function trackPersonalizationPromoClick() {
    tracking.trackEcommerce({
        type: 'promoClick',
        promotions: [
            {
                id: 'personalized-items-categories-carousel',
                name: 'Personalized Items and Categories Carousel',
                creative: 'Personalized Items and Categories Carousel',
                position: 1,
            },
        ],
    });
}

function trackPersonalizationItemClick({ item, variant, url, index }) {
    tracking.trackEcommerce({
        type: 'productClick',
        actionField: {
            list: 'personalized-items-carousel',
        },
        products: [
            {
                id: item.serviceId,
                name: item.title,
                brand: item.seller.sellerId,
                category: url.slice(1, -1),
                position: index + 1,
                variant: `homepage - ${variant}`,
            },
        ],
    });

    tracking.trackEvent({
        category: 'promo interaction',
        action: 'personalized items and categories carousel',
        label: `product clicked-${variant}`,
    });
}

function trackPersonalizationViewAll({ variant }) {
    tracking.trackEvent({
        category: 'promo interaction',
        action: 'personalized items and categories carousel',
        label: `view all clicked-${variant}`,
    });
}

function trackPersonalizationDotClick({ variant }) {
    tracking.trackEvent({
        category: 'promo interaction',
        action: 'personalized items and categories carousel',
        label: `paginate clicked-${variant}`,
    });
}

export {
    trackPersonalizationImpression,
    trackPersonalizationMount,
    trackPersonalizationPromoClick,
    trackPersonalizationItemClick,
    trackPersonalizationViewAll,
    trackPersonalizationDotClick,
};
